module.exports = __webpack_public_path__ + "img/elementlengths_jasp.56109bdf.png";